module.exports = __webpack_public_path__ + "static/media/alert.d069273e.svg";